export default __webpack_public_path__ + "static/media/pH.5cf34140.jpg";